import { render, staticRenderFns } from "./demografiaPopulacional.vue?vue&type=template&id=177d994d&scoped=true&"
import script from "./demografiaPopulacional.vue?vue&type=script&lang=js&"
export * from "./demografiaPopulacional.vue?vue&type=script&lang=js&"
import style0 from "./demografiaPopulacional.vue?vue&type=style&index=0&id=177d994d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d994d",
  null
  
)

export default component.exports